import { Route, Redirect } from "wouter";
import { useAuth } from "@/hooks/use-auth";
import { Loader } from "@/components/ui/loader";

interface PrivateRouteProps {
  component: React.ComponentType;
  path: string;
  requireAdmin?: boolean;
}

export const PrivateRoute = ({
  component: Component,
  path,
  requireAdmin = false,
}: PrivateRouteProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (!user || (requireAdmin && !user.isAdmin)) {
    return <Redirect to="/" />;
  }

  return (
    <Route path={path}>
      <Component />
    </Route>
  );
};
